import React, { useState, useEffect } from 'react'
import axios from 'axios';
import UpcomingAppointmentCard from '../../components/Cards/UpcomingAppointmentCard';
import useAppointments from '../../store/appointments/appointmentsContext';
import useApp from '../../store/app/appContext';
import { MoonLoader }from 'react-spinners';
import { COLORS } from '../../config';
import useWindowSize from '../../hooks/useWindowSize';



function UpcomingAppointmentsCard() {
  
  const [appointments, setAppointments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  const { getPatientAppointments, getPartnerAppointments } = useAppointments();
  
  const { appState: { user, userAccount }} = useApp(); 

  const windowSize = useWindowSize();
  
  const getUpcomingAppointments = (userAppointmentsArray) => {
    //sort by appointment date and return top 2 results
    if (userAppointmentsArray?.length) {
      const formattedArray = [];
      userAppointmentsArray.sort((firstEl, secondEl) => {
        const firstBeforeSecond = -1;
        const secondBeforeFirst = 1;
        const keepOriginalOrder = 0;
        if (firstEl.startTime > secondEl.startTime) return secondBeforeFirst;
        if (firstEl.startTime < secondEl.startTime) return firstBeforeSecond;
        return keepOriginalOrder;
      })
      if (userAppointmentsArray[0]) formattedArray.push(userAppointmentsArray[0]);
      if (userAppointmentsArray[1]) formattedArray.push(userAppointmentsArray[1]);
      return formattedArray;
    }
  }
  
  useEffect(() => {
    let source = axios.CancelToken.source();
    if (appointments.length) return;
    if (userAccount.isPatient) getPatientAppointments(source).then(res => {
      const upcomingAppointments = getUpcomingAppointments(res?.data?.data);
      if (upcomingAppointments) {
        setAppointments(upcomingAppointments);
      } 
      setIsLoading(false);
    }).catch(err => {
      if (axios.isCancel(err)) return;
      setIsLoading(false);
    }); 
    if (userAccount.isPartner) getPartnerAppointments(source).then(res => {
      const upcomingAppointments = getUpcomingAppointments(res?.data?.data);
      if (upcomingAppointments) {
        setAppointments(upcomingAppointments);
      }
      setIsLoading(false);
    }).catch(err => {
      if (axios.isCancel(err)) return;
      setIsLoading(false);
    });; 
    return () => {
      source.cancel();
    }
  }, [userAccount, appointments])  

  return (
    <div className='text-secondary bg-white rounded shadow flex flex-col px-4 md:px-10 py-6 md:py-10 flex-grow overflow-auto md:w-1/2 xl:w-full' style={{ minWidth: '300px', minHeight: '300px' }}>
        <div className='flex justify-between'>
            <h1 className="mb-5 text-2xl text-secondary">Upcoming appointments</h1>
        </div>
        {isLoading && 
        <div className='flex justify-around min-h-170 pt-8'>
          <MoonLoader color={COLORS.colorPrimary}/>
        </div> 
        }
        <div className='h-full w-full md:overflow-scroll pr-4 space-y-4 overflow-auto'>
        {!isLoading ? 
          (appointments.length ? 
            appointments.map(appointment => <UpcomingAppointmentCard key={appointment?.uri} appointment={appointment} />)
            :
            'No upcoming appointments')
          :
          ''
        }
        </div>
    </div>
  )
}

export default UpcomingAppointmentsCard

